require( 'lazysizes/plugins/include/ls.include.js' );
require( 'lazysizes/plugins/unveilhooks/ls.unveilhooks.js' );
require( 'lazysizes' );

import { gsap } from 'gsap'; window.gsap = gsap;
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'; window.ScrollTrigger = ScrollTrigger;
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'; window.ScrollToPlugin = ScrollToPlugin;
import { SplitText } from 'gsap/SplitText.js'; window.SplitText = SplitText;
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin.js'; window.DrawSVGPlugin = DrawSVGPlugin;
import { MotionPathPlugin } from 'gsap/MotionPathPlugin.js'; window.MotionPathPlugin = MotionPathPlugin;
// import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin.js'; window.MorphSVGPlugin = MorphSVGPlugin;
import { CSSPlugin } from 'gsap/CSSPlugin'; window.CSSPlugin = CSSPlugin;

gsap.defaults( {
	ease: 'power2.inOut', 
	duration: 1
} );

gsap.registerPlugin( CSSPlugin );
gsap.registerPlugin( SplitText );
gsap.registerPlugin( ScrollTrigger );
gsap.registerPlugin( ScrollToPlugin );
// gsap.registerPlugin( MorphSVGPlugin );
gsap.registerPlugin( MotionPathPlugin );
gsap.registerPlugin( DrawSVGPlugin );

import ScrollMagic from 'scrollmagic'; window.ScrollMagic = ScrollMagic;
/*
 * require( 'animation.gsap' );
 * require( 'debug.addIndicators' );
 */

import iziModal from 'izimodal/js/iziModal'; jQuery.fn.iziModal = iziModal;
require( '../lib/lightgallery/dist/js/lightgallery.js' );
